/* eslint-disable no-bitwise */
const { escapeRegExp } = require('./strings');

function houseProgram(input, search) {
  let out = input;
  if (search == null) {
    out = input;
  } else {
    out = [];
    const lowerCaseSearch = search.toLowerCase();
    input.forEach((item) => {
      if ((item.address || '').toLowerCase().indexOf(lowerCaseSearch) !== -1) {
        out.push(item);
      } else if ((item.city || '').toLowerCase().indexOf(lowerCaseSearch) !== -1) {
        out.push(item);
      } else if ((item.state || '').toLowerCase().indexOf(lowerCaseSearch) !== -1) {
        out.push(item);
      } else if ((item.zipcode || '').toString().indexOf(lowerCaseSearch) !== -1) {
        out.push(item);
      } else if ((item.houseTags || '').toLowerCase().indexOf(lowerCaseSearch) !== -1) {
        out.push(item);
      } else {
        const user = item.roles.map((role) => {
          return role && role.account && (
            `${role.account.firstName} ${
              role.account.lastName}`
          );
        }).join(' ');
        const Id = item.roles.map((role) => {
          return role && role.accountId;
        }).join(' ');
        if (user.toLowerCase().indexOf(lowerCaseSearch) !== -1) {
          out.push(item);
        } else if (Id.indexOf(lowerCaseSearch) !== -1) {
          out.push(item);
        }
      }
    });
  }
  return out;
}

function houseSearch(input, inSearchString) {
  let searchString = inSearchString;
  if (searchString == null) {
    searchString = '';
  } else {
    searchString = escapeRegExp(searchString);
  }

  const re = new RegExp(searchString, 'gi');
  let out = [];

  if (input && input.length > 0 && searchString.length > 0) {
    out = input.filter((single) => {
      let okay = re.test(single.address);
      okay |= re.test(single.billkey);
      okay |= re.test(single.email);
      okay |= re.test(single.city);
      if (single.account) {
        okay |= re.test(`${single.account.firstName} ${single.account.lastName}`);
      }
      return okay ? single : null;
    });
  }
  return out;
}

module.exports = {
  houseProgram,
  houseSearch,
};
